module.exports = __webpack_public_path__ + "img/woman_raising_hand.128cdaa6.gif";